import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class ReceiptService {

  url: string = 'receipts';

  constructor(private httpClient: HttpClientService) {}

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params)
  }

  getSearchOptions(params: any = {}): Promise<any> {
    params.search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  // Get matters for a contact
  getMattersForContact(contactId: number, matterId?: number): Promise<any> {
    const params: any = { get_matters: true, contact_id: contactId };
    if (matterId) {
      params.matter_id = matterId;
    }
    return this.httpClient.get(`${this.url}.json`, params);
  }

  // Get single matter by ID
  getMatter(matterId: number): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_matter: true, matter_id: matterId });
  }

  // Get matter balance (charges, payments, expenses, escrow, etc.)
  getMatterBalance(matterId: number, matterNumber: string): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_balance: true, matter_id: matterId, matter_number: matterNumber });
  }

  // Get balance due for a matter
  getBalanceDue(matterNumber: string): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_balance_due: true, matter_number: matterNumber });
  }

  // Get payment method by ID
  getPaymentMethod(paymentMethodId: number): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_payment_method: true, payment_method_id: paymentMethodId });
  }

  // Get all payment methods
  getPaymentMethods(): Promise<any> {
    return this.httpClient.get('payment_methods.json');
  }

  // Validate a payment (for Workers' Compensation)
  validatePayment(payment: number, matterNumber: string): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { valid_payment: true, payment: payment, matter_number: matterNumber });
  }

  // Create a new receipt transaction
  create(data: any): Promise<any> {
    return this.httpClient.post(`${this.url}.json`, data);
  }

  // Get new receipt initialization data (for scan redirects)
  getNewReceiptData(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}/new.json`, params);
  }
}
